// trackingEvents.js
// Ecommerce event tracking for GTM (dataLayer) and Meta Pixel (fbq)
// Safe to call even if GTM/fbq haven't loaded (consent not yet given)

function gtmPush(eventData) {
    window.dataLayer = window.dataLayer || []
    if (eventData.ecommerce) {
        window.dataLayer.push({ ecommerce: null })
    }
    window.dataLayer.push(eventData)
}
function fbqTrack(eventName, params) {
    if (window.fbq) {
        window.fbq('track', eventName, params)
    }
}

/**
 * Fired when a user adds an item to the cart (or increases quantity)
 * @param {Object} product - full product object from data/index.js
 * @param {number} quantity - quantity being added (usually 1)
 * @param {string} currency - 'USD' or 'CAD'
 */
export function trackAddToCart(product, quantity, currency) {
    const price = parseFloat(product.srp)

    gtmPush({
        event: 'add_to_cart',
        ecommerce: {
            currency,
            value: price * quantity,
            items: [
                {
                    item_id: product.productID,
                    item_name: product.descriptionTitle,
                    price,
                    quantity,
                },
            ],
        },
    })

    fbqTrack('AddToCart', {
        content_ids: [product.productID],
        content_name: product.descriptionTitle,
        content_type: 'product',
        value: price * quantity,
        currency,
    })
}

/**
 * Fired when a user removes an item from the cart (or decreases quantity)
 * @param {Object} product - full product object
 * @param {number} quantity - quantity being removed (usually 1)
 * @param {string} currency - 'USD' or 'CAD'
 */
export function trackRemoveFromCart(product, quantity, currency) {
    const price = parseFloat(product.srp)

    gtmPush({
        event: 'remove_from_cart',
        ecommerce: {
            currency,
            value: price * quantity,
            items: [
                {
                    item_id: product.productID,
                    item_name: product.descriptionTitle,
                    price,
                    quantity,
                },
            ],
        },
    })

    // Meta Pixel has no standard remove_from_cart event — skip
}

/**
 * Fired when the user clicks the Checkout button (form submits to FoxyCart)
 * @param {Array} cartItems - array of { productIDNum, quantity }
 * @param {Array} data - full product data array (USD or CAD)
 * @param {string} currency - 'USD' or 'CAD'
 */
export function trackBeginCheckout(cartItems, data, currency) {
    const items = cartItems
        .map(({ productIDNum, quantity }) => {
            const product = data.find((p) => p.productIDNum === productIDNum)
            if (!product) return null
            return {
                item_id: product.productID,
                item_name: product.descriptionTitle,
                price: parseFloat(product.srp),
                quantity,
            }
        })
        .filter(Boolean)

    const totalValue = items.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0,
    )

    // 1. STANDARD EVENT: Preserved to ensure existing GA4 reporting does not break
    gtmPush({
        event: 'begin_checkout',
        ecommerce: {
            currency,
            value: totalValue,
            items,
        },
    })

    // 2. NEW CUSTOM EVENT: Core Product Filter for Google Ads Target ROAS
    // Only fires if one of the three main braided reels is in the cart
    const coreReels = ['PBRC1000B2-EB', 'PBRC1000C2-EB', 'PBRC1000W2-EB']
    const hasCoreBraid = items.some((item) => coreReels.includes(item.item_id))

    if (hasCoreBraid) {
        gtmPush({
            event: 'begin_checkout_core_braid',
            ecommerce: {
                currency,
                value: totalValue, // Passes the full cart value, satisfying Target ROAS
                items,
            },
        })
    }

    // 3. META PIXEL: Standard event preserved
    fbqTrack('InitiateCheckout', {
        content_ids: items.map((i) => i.item_id),
        content_type: 'product',
        num_items: items.reduce((sum, i) => sum + i.quantity, 0),
        value: totalValue,
        currency,
    })
}
